var map = {
	"./dashboard/routes.ts": 6773,
	"./lancamento-de-aspectos-socioafetivos-por-aluno/permitir-lancamento-de-aspectos-socioafetivos-por-aluno/routes.ts": 7915,
	"./lancamento-de-aspectos-socioafetivos-por-aluno/permitir-lancamento-de-aspectos-socioafetivos-por-turma/routes.ts": 913,
	"./lancamento-de-aspectos-socioafetivos/permitir-consultar-pendencias-de-lancamento-de-aspectos-socioafetivos/routes.ts": 2842,
	"./lancamento-de-notas-conceitos-faltas/consultar-resumo-de-lancamento-de-notas-conceitos/routes.ts": 4020,
	"./lancamento-de-notas-conceitos-faltas/consultar-resumo-de-lancamento-de-notas-conceitos/turmas-abertas/routes.ts": 2218,
	"./lancamento-de-notas-conceitos-faltas/consultar-resumo-de-lancamento-de-notas-conceitos/turmas-fechadas/routes.ts": 1939,
	"./lancamento-de-notas-conceitos-faltas/consultar-resumo-de-lancamento-de-notas-conceitos/turmas-inicidas/routes.ts": 2724,
	"./lancamento-de-notas-conceitos-faltas/consultar-resumo-de-lancamento-de-notas-conceitos/turmas-nao-inicidas/routes.ts": 2151,
	"./lancamento-de-notas-conceitos-faltas/gerar-resumo-de-lancamento-de-notas-conceitos/routes.ts": 5058,
	"./lancamento-de-notas-conceitos-faltas/lancamento-de-notas-conceitos-faltas-por-turmas/routes.ts": 4813,
	"./lancamento-de-notas-conceitos-faltas/permitir-lancar-quantidade-de-aulas-ministradas-e-planejadas/routes.ts": 2024,
	"./lancar-justificativa/emitir-relatorio-de-justificativa-de-ausencia-de-notas-conceito/routes.ts": 6590,
	"./lancar-justificativa/emitir-relatorio-de-justificativa-de-faltas/routes.ts": 7211,
	"./lancar-justificativa/permitir-lancar-justificativa-ausencia-nota-aluno/routes.ts": 3952,
	"./lancar-justificativa/permitir-lancar-justificativa-de-faltas-por-aluno/routes.ts": 6771,
	"./permitir-importacao-de-notas-conceitos-faltas-de-alunos-transferidos/importacao-de-notas-conceitos-faltas-de-alunos-transferidos/routes.ts": 6765,
	"./permitir-lancamento-notas-faltas-aluno/routes.ts": 9992,
	"./permitir-lancar-nota-recuperacao-final-turma/routes.ts": 7066,
	"./permitir-lancar-votos-conselho-classe/routes.ts": 4405,
	"./ranking-de-desempenho-academico/gerar-ranking-de-desempenho-academico/routes.ts": 9404,
	"./relatorios-de-notas/emitir-boletim-por-aluno/routes.ts": 8535,
	"./relatorios-de-notas/emitir-boletim-por-turma/routes.ts": 5365,
	"./relatorios-de-notas/emitir-declaracao-notas/routes.ts": 2096,
	"./relatorios-de-notas/emitir-parecer-descritivo/routes.ts": 2320,
	"./relatorios-de-notas/emitir-relacao-de-alunos-sem-notas/routes.ts": 2393
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3019;